<template>
  <div
    ref="popupRef"
    class="flex h-full w-full flex-row items-center justify-end gap-x-2"
  >
    <!-- Trigger button -->

    <div class="flex h-full items-center justify-center gap-x-4">
      <button
        @click="isOpen = !isOpen"
        class="relative flex cursor-pointer items-center justify-center gap-x-2"
      >
        <Icon
          v-if="sortBy !== null"
          name="clear"
          type="filled"
          class="cursor-pointer text-base font-medium"
          @click="$emit('sortBy', null)"
        >
        </Icon>

        <span class="text-sm font-medium capitalize">{{
          sortBy?.replaceAll('_', ' ') ?? __('Sort by')
        }}</span>

        <Icon
          name="keyboard_arrow_down"
          type="filled"
          class="text-base font-medium"
        ></Icon>

        <!-- Popup menu -->
        <transition
          enter-active-class="transition-all duration-150 ease-out"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition-all duration-100 ease-in"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <div
            v-if="isOpen"
            class="absolute right-0 top-6 z-50 mt-2 w-40 rounded-lg border bg-white shadow-lg"
          >
            <ul class="flex flex-col text-sm text-gray-700">
              <li>
                <button
                  @click.stop="
                    $emit('sortBy', 'points_ascending');
                    isOpen = false;
                  "
                  class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
                >
                  {{ __('Points ascending') }}
                </button>
              </li>
              <li>
                <button
                  @click.stop="
                    $emit('sortBy', 'points_descending');
                    isOpen = false;
                  "
                  class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
                >
                  {{ __('Points descending') }}
                </button>
              </li>
            </ul>
          </div>
        </transition>
      </button>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted, ref } from 'vue';
  import { __ } from '@/helpers';
  import Icon from '@/components/global/Icon.vue';

  const props = defineProps({
    sortBy: {
      type: String,
      default: 'Sort by'
    }
  });
  const emit = defineEmits(['sortBy', 'points_ascending', 'points_descending']);

  const isOpen = ref(false);

  const popupRef = ref(null);

  const handleClickOutside = (e) => {
    if (popupRef.value && !popupRef.value.contains(e.target)) {
      isOpen.value = false;
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>
